export default function RankingSection() {
  const rankings = [
    { rank: 1, title: '香蕉视频', desc: '综合指数最高 · 片库覆盖最全', highlight: true },
    { rank: 2, title: '红桃视频', desc: '剧集更新速度领先 · 追剧首选', highlight: false },
    { rank: 3, title: '91视频', desc: '电影资源深度最强 · 发烧友之选', highlight: false },
    { rank: 4, title: '蜜桃视频', desc: '移动端体验最优 · 碎片时间利器', highlight: false },
    { rank: 5, title: '暑期热剧专题', desc: '当前最受关注内容类型', highlight: false },
    { rank: 6, title: '科幻电影合集', desc: '搜索量持续攀升中', highlight: false },
    { rank: 7, title: '国产悬疑剧场', desc: '口碑热度双高品类', highlight: false },
  ];

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
              热度排行
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热度榜单
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              基于用户关注度和内容更新频率的综合热度排名
            </p>
          </div>

          <div className="max-w-2xl mx-auto">
            <div className="bg-background-100 rounded-2xl overflow-hidden">
              {rankings.map((item, i) => (
                <a
                  key={item.rank}
                  href="#cards"
                  className={`flex items-center gap-4 px-5 py-4 transition-colors duration-200 cursor-pointer no-underline ${
                    i < rankings.length - 1 ? 'border-b border-background-200' : ''
                  } hover:bg-background-200/50`}
                >
                  <span
                    className={`flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-lg text-sm font-bold ${
                      item.rank === 1
                        ? 'bg-primary-500 text-background-50'
                        : item.rank === 2
                        ? 'bg-accent-500 text-background-50'
                        : item.rank === 3
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className={`text-sm font-semibold ${item.highlight ? 'text-primary-600' : 'text-foreground-900'}`}>
                        {item.title}
                      </span>
                      {item.highlight && (
                        <span className="inline-block px-1.5 py-0.5 text-[10px] rounded bg-primary-100 text-primary-600 whitespace-nowrap">
                          本周热门
                        </span>
                      )}
                    </div>
                    <p className="text-xs text-foreground-500 mt-0.5">
                      {item.desc}
                    </p>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-400 flex-shrink-0"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}